import { render } from "./BtnGroup.vue?vue&type=template&id=ec01450e&scoped=true"
import script from "./BtnGroup.vue?vue&type=script&lang=js"
export * from "./BtnGroup.vue?vue&type=script&lang=js"

import "./BtnGroup.vue?vue&type=style&index=0&id=ec01450e&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec01450e"]])

export default __exports__